import React from "react"

import {FieldTableCellProps} from "../../../../render/table/table-cell"
import {EntityType} from "../../../../../gd/const/item"
import {isBulkSelection} from "../../../../../gd/right-click-menu"
import {ItemModelV2_CalculatedValues} from "../../../../../model2/item2/calculated/@type"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view";

type State = {
    isHovered   : boolean
    showPopover : boolean
}

// const debug = "FieldEstimate_TableCellCalculated"
const debug = false

export default class FieldEstimate_TableCellCalculated extends React.Component<FieldTableCellProps, State> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    get isEditable():boolean {
        switch (this.props.listItem.type) {

            case EntityType.TASK:
                return !this.props.manager.isReadOnly && this.props.listItem.task.acl.canChangeEstimate

            case EntityType.PROJECT:
                return !this.props.manager.isReadOnly && this.props.listItem.project.acl.canChangeEstimate

            default:
                return false
        }
    }

    onMouseEnter = () => {
        if (!this.isEditable) {
            return
        }

        if (!this.state.isHovered) {
            this.setState({
                isHovered   : true
            })
        }
    }

    onMouseLeave = () => {
        if (this.state.showPopover) {
            return
        }

        if (this.state.isHovered) {
            this.setState({
                isHovered   : false
            })
        }
    }

    onValueChange = (value:number|null, hidePopover:boolean=true) => {
        switch (this.props.listItem.type) {
            case EntityType.TASK:
                this.props.listItem.task.estimate = value
                this.props.listItem.task.save() // no await !
                break

            case EntityType.PROJECT:
                this.props.listItem.project.estimate = value
                this.props.listItem.project.save() // no await !
                break

            case EntityType.EVENT:
            default:
                return
        }

        // need it because of calculated values
        this.props.manager.updateChildrenItems()

        hidePopover && this.hidePopover()

        debug && console.log(debug, "need rerender")

        FieldProto_updateView(this.props.manager, this.props.field)
    }

    onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) {
            return
        }
        e.stopPropagation()
        this.onValueChange(null, false)
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) {
            return
        }
        if (!this.isEditable) {
            return
        }

        this.setState({
            showPopover     : !this.state.showPopover
        })

    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    get style() {

        // this is common part for table cell
        // end common part

        const width = this.props.column.width

        const style : style = _.clone(this.props.style) || {} // we need clone here because we add width!
        style.width = width

        return style
    }

    renderHovered() {
        // const showChildren  = this.props.listItem.view.isCollapsed && this.props.listItem.calculated.estimated.children>0

        const calculatedValues: ItemModelV2_CalculatedValues | undefined = this.props.listItem.calculated.dataByAggregateFunction[this.props.field.fieldId as keyof {}]?.[this.props.column.aggregateFunction!]
        const ownValue = calculatedValues?.own || this.props.field.getViewValue(this.props.listItem.item)

        const showSummaryView   = /*this.props.listItem.isGroup ||*/ this.props.listItem.view.isCollapsed
        const showChildren      = showSummaryView && !!calculatedValues?.children.value && calculatedValues?.children.value > 0
        const showOwnValue      = ownValue > 0
        // const showFieldLabel    = !showOwnValue && !showChildren
        const showPlus          = showOwnValue && showChildren
        const showReset         = this.isEditable && showOwnValue

        return (
            <div className="cell-flex is-hovered ui5-txt-less-important-small" style={this.style} onMouseEnter={this.onMouseEnter}
                 onMouseLeave={this.onMouseLeave}>
                <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent"
                     onClick={this.onClick}>

                    <div className="flex-row-left-center truncate">

                        {/*{showFieldLabel && this.props.field.label}*/}

                        {showOwnValue &&
                            <div className="ui5-txt-less-important-small">
                                {gd.utils.minutesHumanize(ownValue)}
                            </div>}

                        {showPlus &&
                            <div className="ui5-txt-less-important-small m-r-5 m-l-5">+</div>}

                        {showChildren &&
                            <>
                                <div className="ui5-ico-12 i5-folder-tree m-r-5 m-t-1"/>
                                <div className="ui5-txt-less-important-small">
                                    {gd.utils.minutesHumanize(calculatedValues?.children.value)}
                                </div>
                            </>}

                        {this.state.showPopover &&
                            <this.props.field.components.PopoverMenu {...this.props} parent={this}/>}
                    </div>

                    <div className="buttons">
                        {showReset &&
                            <div className="btn-reset" onClick={this.onDeleteClick}/>}
                        <div className="btn-arrow"/>
                    </div>
                </div>
            </div>
        )
    }

    renderNotHovered() {
        const classes = Classes("cell-flex ui5-field-editable size-small ui5-txt-less-important-small", this.props.column.id, {
            // 'is-expanded-calculated': this.props.listItem.isGroup && !this.props.listItem.view.isCollapsed
        })

        const showSummaryView   = /*this.props.listItem.isGroup ||*/ this.props.listItem.view.isCollapsed
        let notHoveredContent   = null
        let aggregateIcon

        const calculatedValues: ItemModelV2_CalculatedValues | undefined = this.props.listItem.calculated.dataByAggregateFunction[this.props.field.fieldId as keyof {}]?.[this.props.column.aggregateFunction!]
        const ownValue = calculatedValues?.own || this.props.field.getViewValue(this.props.listItem.item)

        debug && console.log(debug, "renderNotHovered", showSummaryView, calculatedValues)

        if (showSummaryView && !!calculatedValues?.total.value && calculatedValues.total.value != calculatedValues.own) {
            notHoveredContent = calculatedValues.total.value
            aggregateIcon = <div className={Classes("ui5-ico-12 m-r-5 m-t-1", this.props.column.aggregator?.icon)}/>
        } else if (ownValue > 0) {
            notHoveredContent = ownValue
        }

        return (
            <div className      = {classes}
                 style          = {this.style}
                 onMouseEnter   = {this.onMouseEnter}
                 onMouseLeave   = {this.onMouseLeave}>
                {aggregateIcon}

                {!!notHoveredContent &&
                    gd.utils.minutesHumanize(notHoveredContent)}
            </div>
        )
    }

    render() {
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered) {
            return this.renderHovered()
        } else {
            return this.renderNotHovered()
        }
    }
}



